<template>
  <div class="sd--overlay flex align-center justify-center">
    <div class="window oval">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubDialog"
}
</script>

<style>
.sd--overlay {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.1);
}
.sd--overlay > .window {
  position: relative;
  width: 60%;
  padding-bottom: 20px;
  height: auto;
  background-color: white;
  box-shadow: 0 1px 2px rgba(0,0,0,0.07),
              0 2px 4px rgba(0,0,0,0.07),
              0 4px 8px rgba(0,0,0,0.07),
              0 8px 16px rgba(0,0,0,0.07),
              0 16px 32px rgba(0,0,0,0.07),
              0 32px 64px rgba(0,0,0,0.07);
  overflow: hidden;
}
.sd--overlay > .window > button {
  position: absolute;
  z-index: 9;
  top: 10px;
  right: 10px;
  margin-left: auto;
  height: 40px;
  width: 40px;
}
.sd--overlay > .window > button:hover {
  background-color: rgba(245, 246, 250, .3);
  border-radius: 14px;
}
.sd--overlay > .window > button > img {
  position: relative;
  top: 2px;
  width: 20px;
  height: 20px;
}
.sd--overlay > .window > img.sub-dialog-image {
  width: 100%;
}
.sd--overlay.test > .window > img.sub-dialog-image {
  width: 130%;
}
.sd--overlay > .window > img.sub-dialog-image.absolute {
  left: 0;
  top: 0;
}
.sd--overlay > .window > .substitute {
  position: relative;
  overflow: hidden;
  height: 100%;
  border-radius: 14px;
}
.sd--overlay > .window > .substitute > img {
  width: 100%;
  height: 100%;
}
.sd--overlay > .window > .substitute > img.absolute {
  left: 0;
  top: 0;
}
.sd--overlay > .window > h4.title {
  margin-top: 10px;
  font-weight: 400;
  font-size: 1.2rem;
  padding: 10px 30px;
}
.sd--overlay > .window > p.content {
  font-size: .9rem;
  color: #797979;
  padding: 0 30px 10px;
}
</style>
